import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks/use-pagination-query";
import { http } from "../../../utils/http";

function fetchEventList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/event", baseUrl);

  if (params.title) {
    endpointUrl.searchParams.append("title", params.title);
  }
  if (params.contents) {
    endpointUrl.searchParams.append("contents", params.contents);
  }
  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useEventList(params = {}) {
  return usePaginationQuery(
    [
      "event",
      params.title,
      params.contents,
      params.from,
      params.to,
      params.status,
    ],
    (paginationState) => fetchEventList({ ...params, ...paginationState })
  );
}
async function addEvent(formData) {
  const data = await http(`/admin/event`, {
    data: formData,
  });
  return data;
}

export function useAddEvent() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(addEvent, {
    onSuccess: () => {
      queryClient.refetchQueries(["event"]);
      setTimeout(() => {
        navigate("/bulletin-board/");
      }, 1500);
    },
  });
}

export function useUpdateEvent() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/event/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(["event"]);
        setTimeout(() => {
          navigate("/bulletin-board/");
        }, 1500);
      },
    }
  );
}

async function deleteEventById(id) {
  const data = await http(`/admin/event/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteEventById() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteEventById, {
    onSuccess: () => {
      queryClient.invalidateQueries(["event"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

async function endEventById(id) {
  const data = await http(`/admin/event/${id}/end`, {
    method: "PATCH",
  });

  return data;
}

export function useEndEventById(id) {
  const queryClient = useQueryClient();
  return useMutation(endEventById, {
    onSuccess: () => {
      queryClient.invalidateQueries(["event-detail", id]);
    },
  });
}

export async function fetchEventDownload() {
  const { data } = await http(`/admin/event-download`, {
    responseType: "blob",
  });

  return data;
}

export function useEventDownload() {
  const { data, ...raResult } = useQuery(["event-download"], () =>
    fetchEventDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
